import * as turf from "@turf/turf";
import type mapboxgl from "mapbox-gl";

export const isValidBbox = (
  bbox: number[] | undefined | null
): bbox is [number, number, number, number] => {
  if (!bbox || bbox.length < 4) return false;
  const [west, south, east, north] = bbox;
  return (
    Number.isFinite(west) &&
    Number.isFinite(south) &&
    Number.isFinite(east) &&
    Number.isFinite(north) &&
    south >= -90 &&
    south <= 90 &&
    north >= -90 &&
    north <= 90 &&
    west >= -180 &&
    west <= 180 &&
    east >= -180 &&
    east <= 180
  );
};

export const safeFitBounds = (
  map: mapboxgl.Map,
  polygon: any,
  errorMessage: string
): boolean => {
  try {
    const bbox = turf.bbox(polygon);
    if (!isValidBbox(bbox)) {
      console.warn(errorMessage, bbox);
      return false;
    }
    map.fitBounds(bbox, { animate: false });
    return true;
  } catch (error) {
    console.error(errorMessage, error);
    return false;
  }
};
